import { useQuery } from "react-query";
import { fetchTokenState } from "../queries/tokens.queries";

export const useTokenState = (token: string) => {
    return useQuery(['token', token], () => {
        try {
            return fetchTokenState(token);
        } catch (err) {
            return null;
        }
    });
};